
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.75735 7.34314C7.20507 7.34314 6.75735 6.89543 6.75735 6.34314C6.75735 5.79086 7.20507 5.34314 7.75735 5.34314L17.6568 5.34314C18.2091 5.34314 18.6568 5.79085 18.6568 6.34314V16.2426C18.6568 16.7949 18.2091 17.2426 17.6568 17.2426C17.1046 17.2426 16.6568 16.7949 16.6568 16.2426V8.75735L7.05025 18.364C6.65972 18.7545 6.02656 18.7545 5.63603 18.364C5.24551 17.9734 5.24551 17.3403 5.63603 16.9497L15.2426 7.34314L7.75735 7.34314Z","fill":"#16171F"}})])
          )
        }
      }
    